import loadable from '@loadable/component';

export const CmsEmailCampaignSignupDoubleBlockLoadable = loadable(
  () => import('./CmsEmailCampaignSignupDoubleBlock'),
  { resolveComponent: (module) => module.CmsEmailCampaignSignupDoubleBlock },
);
